/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getCompanySettings,
  getFeturePermission,
  getMenuByModule,
  getModuleList,
} from "../../../../../app/modules/Auth/redux/authCrud";
import { actions } from "../../../../../app/modules/Auth/redux/authRedux";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { SiLitiengine } from "react-icons/si";
import jwtDecode from "jwt-decode";
import * as LetterAction from "../../../../../app/pages/letter-management/_redux/letterManagementActions";

export function LanguageSelectorDropdown(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { modules, user } = useSelector((state) => state.auth);
  const { authToken } = useSelector(
    ({ auth }) => ({
      authToken: auth.coreModuleInfo,
    }),
    shallowEqual
  );

  const menuType =
    localStorage.getItem("menuType") &&
    JSON.parse(localStorage.getItem("menuType"));

  const getModuleLists = async () => {
    await getModuleList().then(async (res) => {
      if (!res.error) {
        dispatch(actions.modules(res?.data));

        const findOne = res?.data?.find((item) => item?.module_name == "HRMS");

        if (findOne && Object.keys(findOne).length > 0) {
          const data = {
            type: findOne.module_name,
            id: findOne.module_id,
            slug: findOne.module_url,
          };
          // await getPermission();
          await getMenu(data);
          localStorage.setItem("menuType", JSON.stringify(data));
          dispatch(actions.menuType(data));
        }
      }
    });
  };

  const flatMenus = (data) => {
    const menus = [];
    const runRecursiveAndFlat = (item) => {
      if (item.children.length) {
        menus.push({
          menu_id: item.menu_id,
          parent_menu_id: item.parent_menu_id,
          parent: [],
          menu_url: item.menu_url,
        });
        for (let menu of item.children) {
          runRecursiveAndFlat(menu);
        }
      } else {
        menus.push({
          menu_id: item.menu_id,
          parent_menu_id: item.parent_menu_id,
          parent: [],
          menu_url: item.menu_url,
        });
      }
    };

    for (let item of data) {
      runRecursiveAndFlat(item);
    }

    let menuObj = {};

    for (let menu of menus) {
      menuObj[menu.menu_id] = {
        menu_id: menu.menu_id,
        parent_menu_id: menu.parent_menu_id,
        parent: [],
        menu_url: menu.menu_url,
      };
    }

    for (let menu of menus) {
      if (menuObj[menu.parent_menu_id]) {
        menuObj[menu.menu_id].parent.push(menuObj[menu.parent_menu_id]);
      }
    }
    return { menuObj, flatMenu: menus };
  };
  const getMenu = async (menuType) => {
    if (menuType?.id) {
      await getMenuByModule(menuType.id, 1).then((res) => {
        if (res?.success) {
          let menuItems = res?.data;
          let { menuObj, flatMenu } = flatMenus(menuItems);
          getCompanySettings().then((res) => {
            const data = res.data.data;
            dispatch(actions.companySettings(data));
          });

          dispatch(actions.menu(menuItems, menuObj, flatMenu));
        }
      });
    }
  };

  const getPermission = async () => {
    try {
      const permissions = (await getFeturePermission()).data?.map(
        (d) => d.name
      );
      dispatch(actions.setFEPermission(permissions));
    } catch (e) {
      console.log(e);
    }
  };

  const handleModule = async (type, id, slug) => {
    const data = {
      type: type,
      id: id,
      slug: slug,
    };
    // localStorage.setItem("menuType", JSON.stringify(data));
    // dispatch(actions.menuType(data));
    if (data.type != "HRMS") {
      window.location.href = `${process.env.REACT_APP_ERP_FE}/?moduleId=${data.id}`;
    }
    // await getMenu(data);
    // return history.push(`/dashboard/${slug}`);
  };

  useEffect(() => {
    if (authToken && Object.keys(authToken).length > 0) {
      getModuleLists();
    }
  }, [authToken]);

  useEffect(() => {
    let menuType =
      localStorage.getItem("menuType") &&
      JSON.parse(localStorage.getItem("menuType"));

    // if (defaultModule && Object.keys(defaultModule).length > 0) {
    // }

    if (menuType) {
      dispatch(actions.menuType(menuType));
    }
  }, []);

  useEffect(() => {
    if (authToken && Object.keys(authToken).length > 0) {
      dispatch(LetterAction.getAllLetterVariables());
      dispatch(LetterAction.getAllApplicantVariables());
    }
  }, [dispatch, authToken]);

  return (
    <Dropdown>
      <Dropdown.Toggle
        id="dropdown-basic"
        variant="light"
        // style={{ background: "#fff", border: 0, padding: 0 }}
        // className="bg-white"
        className="module_selection"
      >
        <div
          className="btn btn-dropdown btn-lg mr-1 topbar-helper"
          style={{
            color: "rgba(0, 0, 0, 0.65)",
            fontSize: "14px",
            fontFamily: "Inter",
            fontWeight: "400",
          }}
        >
          <SiLitiengine className="topbar-helper" />{" "}
          {menuType?.type ?? "Select Module"} <MdOutlineKeyboardArrowDown />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround"
        style={{ maxHeight: "90vh", overflowY: "auto", width: "202px" }}
      >
        {modules &&
          modules.length > 0 &&
          modules.map((item, i) => (
            <Dropdown.Item
              className={"px-3 py-1"}
              key={i}
              onClick={() =>
                handleModule(item.module_name, item.module_id, item.module_url)
              }
            >
              <a className="nav-link">
                <span className="navi-text">{item.module_name}</span>
              </a>
            </Dropdown.Item>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
